document.addEventListener('DOMContentLoaded', function () {

    function submitModShopProductForm(productPrice, recipeSetId, productImage, variantID) {

      const formData = {
        items: [
          {
            id: variantID,
            quantity: 1,
            properties: {
                _modshop_price: productPrice,
                _modshoprecipeid: recipeSetId,
                _custom_image: productImage
            },
          }
        ]
      };

      console.log(recipeSetId)

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(data => {
        console.log('Product added:', data);
        // window.toggleModShopDrawer();
      })
      .catch(error => {
        console.error('Error adding product:', error);
      });
    }

    window.submitModShopProductForm = submitModShopProductForm;
  });
